<template>
  <div :class="is_en ? 'cases en' : 'cases'">
    <el-menu
      default-active="0"
      active-text-color="#FF6B35"
      @select="handleSelect"
      class="el-menu-vertical-demo">
      <el-menu-item  v-for="(item, index) in list" :index="String(index)">
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-menu>
    <div class="content">
      <el-card shadow="hover">
        <div class="title">{{list[activeIndex].title}}</div>
        <div class="desc">
          {{list[activeIndex].desc}}
        </div>
        <div class="sub-title">{{$t('project1')}}</div>
        <div class="sub-desc">{{list[activeIndex].p1}}</div>
        <div class="sub-title">{{$t('project2')}}</div>
        <div class="sub-desc">{{list[activeIndex].p2}}</div>
        <div class="sub-title">{{$t('project3')}}</div>
        <div class="sub-desc">{{list[activeIndex].p3}}</div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "cases",
  data() {
    return {
      activeIndex: 0,
    }
  },
  computed: {
    is_en() {
      return this.$t('language') === 'English'
    },
    list() {
      return [
        {
          title: this.$t('cases.case1.title'),
          desc: this.$t('cases.case1.desc'),
          p1: this.$t('cases.case1.p1'),
          p2: this.$t('cases.case1.p2'),
          p3: this.$t('cases.case1.p3')
        },
        {
          title: this.$t('cases.case2.title'),
          desc: this.$t('cases.case2.desc'),
          p1: this.$t('cases.case2.p1'),
          p2: this.$t('cases.case2.p2'),
          p3: this.$t('cases.case2.p3')
        },
        {
          title: this.$t('cases.case3.title'),
          desc: this.$t('cases.case3.desc'),
          p1: this.$t('cases.case3.p1'),
          p2: this.$t('cases.case3.p2'),
          p3: this.$t('cases.case3.p3')
        },
        {
          title: this.$t('cases.case4.title'),
          desc: this.$t('cases.case4.desc'),
          p1: this.$t('cases.case4.p1'),
          p2: this.$t('cases.case4.p2'),
          p3: this.$t('cases.case4.p3')
        },
        {
          title: this.$t('cases.case5.title'),
          desc: this.$t('cases.case5.desc'),
          p1: this.$t('cases.case5.p1'),
          p2: this.$t('cases.case5.p2'),
          p3: this.$t('cases.case5.p3')
        },
        {
          title: this.$t('cases.case6.title'),
          desc: this.$t('cases.case6.desc'),
          p1: this.$t('cases.case6.p1'),
          p2: this.$t('cases.case6.p2'),
          p3: this.$t('cases.case6.p3')
        },
        {
          title: this.$t('cases.case7.title'),
          desc: this.$t('cases.case7.desc'),
          p1: this.$t('cases.case7.p1'),
          p2: this.$t('cases.case7.p2'),
          p3: this.$t('cases.case7.p3')
        }
      ]
    }
  },
  methods: {
    handleSelect(index, indexPath) {
      console.log(index)
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
.cases {
  width: 1000px;
  margin: 0 auto;
  position: relative;
  padding-left: 250px;
  line-height: 2;
  min-height: calc(100vh - 60px - 60px);
  &.en {
    padding-left: 320px;
    .el-menu-vertical-demo {
      width: 320px;
      .el-menu-item {
        white-space: normal;
        line-height: normal; /* 调整行高 */
      }
    }
  }
  .image-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .sub-title {
    color: #FF6B35;
    position: relative;
    padding: 5px 0 5px 10px;
    &:before {
      position: absolute;
      top: 15px;
      left: 0;
      content: '';
      width: 2px;
      height: 10px;
      background: #FF6B35;
    }
  }
  .sub-desc {
    font-size: 14px;
  }
  .el-menu-vertical-demo {
    position: absolute;
    left: 0;
    top: 30px;
    width: 250px;
    border-left: solid 1px #e6e6e6;
    border-right: 0;
    .el-menu-item:focus,.el-menu-item:hover {
      background-color: #FFEFE9;
    }
    .el-menu-item {
      position: relative;
      color: #999;
    }
    .el-menu-item.is-active {
      font-weight: 700;
    }
    .el-menu-item.is-active:before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 100%;
      background: #FF6B35;
    }
  }
  .content {
    padding: 30px 0 30px 40px;
    .title {
      font-size: 20px;
      color: #FF6B35;
      padding-bottom: 20px;
    }
    img {
      display: block; height: 250px;margin: 0 auto
    }
    .desc {
      font-size: 14px;
      padding-bottom: 20px;
    }
  }
}
</style>